import React from 'react'

import Base from '../_Base'

const PlayOutline = (props) => (
  <Base width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      d="M5.945 3C5.385 3 5 3.434 5 4.19v15.62c0 .752.384 1.19.946 1.19.234 0 .499-.076.78-.237l13.56-7.774c.95-.544.953-1.432 0-1.978L6.727 3.237C6.444 3.077 6.178 3 5.944 3m1.057 2.658L18.063 12 7.001 18.342l.001-12.684"
      fillRule="evenodd"
    />
  </Base>
)

export default PlayOutline
